import React, { useEffect, useState, useReducer, useCallback } from "react";

import { mapValues as _mapValues } from "lodash";

import { setAccountDetails } from "../../../services/account/AccountService";

import { getAuthData } from "../../../services/authentication/AuthenticationService";

import {
    authenticate,
    onAuthenticateSuccess,
    onAuthenticateFailure
} from "../helpers/authenticate";
import LoginForm from "../LoginForm";
import useAuthenticateReducer, { initialState } from "../useAuthenticateReducer";

// We should be able to use the iframes window context to determine the login domain: ex: "proj10.retirementpartner.com"
const LOGIN_DOMAIN = window.location.origin || "https://participant.empower-retirement.com";

const LoginFormContainerNative = () => {
    const [accuCode, setAccuCode] = useState("Empower");

    const [authCalled, setAuthCalled] = useState(false);
    const [loggingInState, setLoggingInState] = useState(false);
    const [showLogin, setShowLogin] = useState(true);

    const [authentication, dispatch] = useReducer(useAuthenticateReducer, initialState);

    const getParamValue = () => {
        const isIframeLandingPage = window.location.href.indexOf("iframe") > -1;
        if (!isIframeLandingPage) {
            window.location.reload();
        }
        const paramName = "deeplink";
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const deeplinkParam = urlParams.get(paramName);
        return deeplinkParam || "";
    };

    useEffect(() => {
        if (!authCalled) {
            getAuthData().then(
                (results) => {
                    setAuthCalled(true);
                    function propertyToBoolean(val) {
                        const booleanState = ["false", "true"].indexOf(val);
                        return booleanState >= 0 ? Boolean(booleanState) : val;
                    }

                    const authenticationStatus = _mapValues(results, propertyToBoolean);

                    console.log("container - authenticated", authenticationStatus.authenticated);
                    if (authenticationStatus.authenticated) {
                        setAccountDetails().then(function (response) {
                            window.accu = response.accuCode;
                            setAccuCode(response.accuCode);
                        });
                    } else {
                        console.log("not authenticated...");
                        if (String(window.location.href).indexOf("accu=") > -1) {
                            const accuIndx = String(window.location.href).indexOf("accu=");
                            const pageAccu = String(window.location.href).substring(accuIndx + 5);
                            setAccuCode(pageAccu);
                        }
                        // TBD clear duplicate cookies
                        const currentUrl = window.location.href;
                        if (
                            currentUrl.indexOf("participant") >= 0 &&
                            currentUrl.indexOf("login") >= 0
                        ) {
                            console.log("Try to clear cookies...");
                            // clears spanish cookies; probably not needed...
                        }
                    }
                },
                (err) => {
                    console.log("Get Auth Error: ", err);
                }
            );
        }
    }, [authCalled]);

    const registerButtonClick = () => {
        setShowLogin(false);
    };

    const openAccountClick = () => {
        setShowLogin(false);
        const href = "/participant/#/articles/MYERIRA/openAnAccount";
        window.location.assign(href);
    };

    /**
     * on click submit
     */
    const handleAuthenticate = useCallback(
        async ({ username, password }) => {
            try {
                const deeplinkParam = getParamValue();

                const authData = await authenticate({
                    accuCode,
                    deeplinkParam,
                    username,
                    password,
                    setLoggingInState,
                    dispatch
                });

                const href = await onAuthenticateSuccess({
                    accuCode,
                    authData,
                    dispatch,
                    setLoggingInState,
                    setAccuCode
                });

                //Redirect to where it needs to go
                const redirectUrl =
                    deeplinkParam && deeplinkParam !== ""
                        ? href + "?noScope=true&deepLinkParam=" + deeplinkParam
                        : href;

                window.location.assign(redirectUrl);
            } catch (error) {
                const href = onAuthenticateFailure({
                    error: error.data,
                    dispatch,
                    setLoggingInState,
                    setShowLogin,
                    loginDomain: LOGIN_DOMAIN
                });

                if (href) {
                    //Redirect to where it needs to go
                    window.location.assign(href);
                    //window.top.location.href = href;
                }
            }
        },
        [accuCode]
    );

    return (
        <React.Fragment>
            <main id="main-body" className="container with-breadcrumb with-top-margin">
                <div className="container row">
                    <div className="row">
                        <LoginForm
                            accu={accuCode}
                            authentication={authentication}
                            authenticateInput={handleAuthenticate}
                            loggingIn={loggingInState}
                            showLoginUpd={showLogin}
                            errorCode={authentication.errorCode}
                            errorMessageParams={authentication.errorMessageParams}
                            registerButtonClickInput={registerButtonClick}
                            openAccountClickInput={openAccountClick}
                            loginDomain={LOGIN_DOMAIN}
                        />
                    </div>
                </div>
            </main>
        </React.Fragment>
    );
};

export default LoginFormContainerNative;
